"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StyledPopover = require("./StyledPopover");

var _excluded = ["addToGallery", "closeButton", "togglePopover", "placement", "trigger", "content", "infiniteScroll", "overlayClassName", "onVisibleChange", "target", "title", "visible", "width", "height", "infiniteScrollContainerRef"];

// VARIATIONS
// 1. Default (responsive height, adjustable width)
// 2. Dropdown Menu (dropdownMenu)
// NOTE: At small resolutions, the popover turns into a centered modal with
// a semi-transparent black mask in the background.
// NOTE: The visibility of this popover component must be handled via props.
function Popover(_ref) {
  var addToGallery = _ref.addToGallery,
      closeButton = _ref.closeButton,
      togglePopover = _ref.togglePopover,
      placement = _ref.placement,
      trigger = _ref.trigger,
      content = _ref.content,
      infiniteScroll = _ref.infiniteScroll,
      overlayClassName = _ref.overlayClassName,
      onVisibleChange = _ref.onVisibleChange,
      target = _ref.target,
      title = _ref.title,
      visible = _ref.visible,
      width = _ref.width,
      height = _ref.height,
      infiniteScrollContainerRef = _ref.infiniteScrollContainerRef,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var dataId = addToGallery ? 'add-to-gallery-menu-close-button' : null;

  var popoverContent = /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverContainer, (0, _extends2["default"])({
    width: width,
    height: height
  }, rest), (title || closeButton) && /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverTitleContainer, rest, title, closeButton &&
  /*#__PURE__*/

  /* To implement the close button, manually handle visibility (`visible`
  attribute) using state. Pass a toggle state function to the popover and
  also set state in the `onVisibleChange` callback. */
  _react["default"].createElement(_StyledPopover.PopoverClose, {
    "data-id": dataId,
    onClick: togglePopover
  })), /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverContent, (0, _extends2["default"])({
    infiniteScroll: infiniteScroll,
    ref: infiniteScrollContainerRef
  }, rest), content));
  /* PopoverMask will only work with the visible prop */


  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StyledPopover.StyledPopover, (0, _extends2["default"])({
    "class": "popover",
    placement: placement,
    trigger: trigger,
    content: popoverContent,
    overlayClassName: overlayClassName,
    onVisibleChange: onVisibleChange,
    visible: visible
  }, rest), target), /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverMask, {
    visible: visible
  }));
}

Popover.defaultProps = {
  addToGallery: false,
  closeButton: false,
  infiniteScroll: false,
  togglePopover: null,
  overlayClassName: 'styled_popover',
  onVisibleChange: null,
  placement: 'right',
  title: null,
  trigger: 'hover',
  width: null,
  height: null,
  infiniteScrollContainerRef: null,
  zIndex: 9999
};
Popover.propTypes = {
  addToGallery: _propTypes["default"].bool,
  content: _propTypes["default"].node.isRequired,
  closeButton: _propTypes["default"].bool,
  infiniteScroll: _propTypes["default"].bool,
  togglePopover: _propTypes["default"].func,
  overlayClassName: _propTypes["default"].string,
  onVisibleChange: _propTypes["default"].func,
  placement: _propTypes["default"].string,
  target: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].node,
  trigger: _propTypes["default"].string,
  visible: _propTypes["default"].bool.isRequired,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  infiniteScrollContainerRef: _propTypes["default"].func,
  zIndex: _propTypes["default"].number
};
var _default = Popover;
exports["default"] = _default;